import React, { JSX, useState } from 'react';

interface InputNumberProps {
  labelTitle: string;
  labelStyle?: string;
  type?: string;
  containerStyle?: string;
  defaultValue?: number;
  placeholder?: string;
  updateFormValue: (updateType: string, value: number) => void; // Updated function signature
  updateType: string;
}

function InputNumber({
  type,
  labelTitle,
  containerStyle,
  defaultValue,
  placeholder,
  updateFormValue,
  updateType,
}: InputNumberProps): JSX.Element {
  const [value, setValue] = useState<number>(defaultValue || 0);

  const updateInputValue = (val: number): void => {
    setValue(val);
    updateFormValue(updateType, val); // Pass both updateType and value
  };

  return (
    <div className={`form-control w-full ${containerStyle}`}>
      <fieldset className="fieldset">
              <legend className="fieldset-legend">{labelTitle}</legend>
              <input
        type={type || 'text'}
        value={value}
        placeholder={placeholder || ''}
        onChange={(e) => updateInputValue(+e.target.value)}
        className="input input-bordered w-full"
      />
              {/* <p className="fieldset-label">Optional</p> */}
      </fieldset>
    </div>
  );
}

export default InputNumber;
